import { createRoot } from 'react-dom/client';

import 'core-js/actual';

import App from './App';
import { branchInit } from './branch';
import { sentryInit } from './sentryInit';

if (process.env.NODE_ENV === 'production') {
  sentryInit();
  branchInit();
}

const container = document.getElementById('react-root');
const root = createRoot(container);
root.render(<App />);
